import React from 'react';
import { useIntl } from 'react-intl';

import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import { getAlbertaRedirectUrl, redirectToExternalSite } from '@/utils/alberta-redirect';

function PromotionsRestrictedNotice(): JSX.Element {
  const intl = useIntl();

  // The notice only renders for restricted-mode users, who are always logged in,
  // so link to LuckyDays AB with the logged-in btag — same redirect the Alberta
  // migration modals use.
  const redirectUrl = getAlbertaRedirectUrl('roc', true, true);

  const onGo = (e: React.MouseEvent<HTMLAnchorElement>) => {
    triggerGTag(GTagEvents.alberta_migrate_cta);
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
      return; // let the browser handle modifier/middle clicks natively
    }
    e.preventDefault();
    redirectToExternalSite(redirectUrl);
  };

  return (
    <div className="text-center max-w-xl mx-auto py-8">
      <h2 className="mb-4">{intl.formatMessage({ id: 'promotions.restricted.header' })}</h2>
      <p>
        {intl.formatMessage(
          { id: 'promotions.restricted.text' },
          {
            a: (chunks: React.ReactNode) => (
              <a
                href={redirectUrl}
                onClick={onGo}
                className="font-semibold text-blue-light underline"
              >
                {chunks}
              </a>
            ),
          },
        )}
      </p>
    </div>
  );
}

export default PromotionsRestrictedNotice;
